import * as React from "react";
import {Box, Checkbox, FormControlLabel, Stack, Typography} from "@mui/material";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {truncateStr} from "../Service";
import MailOutlineIcon from "@mui/icons-material/MailOutline";

const AssociationBox = ({mail,name, index, userChecked, setUserChecked}) => {
    const {mode} = useDarkMode();
    const handleChange = (checked) => {
        console.log(userChecked);
        console.log(checked);
        if (checked) {
            setUserChecked(mail)
        } else {
            setUserChecked('');
        }
    }

    const isChecked = mail === userChecked;
    return (
        <Box className={'profile-associate'} sx={{backgroundColor : mode.settings.backgroundColor}}>
            <FormControlLabel
                control={<Checkbox checked={isChecked} onChange={(event) => {handleChange(event.target.checked)}}/>}
                label={<Typography variant={'body2'} color={mode.settings.textColor10}>{name}</Typography>}
            />
            <Stack direction={'row'} marginLeft={{xs : '0px' , md : '0px' ,lg : '0px'}} marginTop={'5px'} flexWrap={"nowrap"}>
                <MailOutlineIcon sx={{marginRight : '5px', color: mode.settings.textColor3}}/>
                <Typography color={mode.settings.textColor10}>Email</Typography>
                <Typography variant={'body2'} color={mode.settings.textColor10} marginLeft={'10px'}>{truncateStr(mail,27)}</Typography>
            </Stack>
        </Box>
    )
}

export default AssociationBox
